import { connectMediaStore } from './withOwnReduxStore';
import { getFlags } from '@wix/da-react-context/pkg/flags/redux/selectors';
export default connectMediaStore((state)=>({
        flags: Object.keys(getFlags(state))
    }), {});

//# sourceMappingURL=withFeatureFlags.js.map